import Image from "next/legacy/image";
import Link from "next/link";
import React from "react";
import { useContext } from "react";
import { isMobileContext } from "../../contexts/isMobileContext";
import { nextRouteContext } from "../../contexts/nextRouteContext";
import { BASE_URL } from "../../utils/FetchData";
import Button from "../common/Button";
import { AnimatePresence, motion } from "framer-motion";
import FadeIn from "../Animations/FadeIn";
import { useEffect } from "react";

export default function MasterplanMainCard({ cardInfo, projectSlug, showData, setShowData, setActivePhase, facility }) {
	const { isMobile } = useContext(isMobileContext);
	const { setNextRoute } = useContext(nextRouteContext)
	return (
		<AnimatePresence
			key={facility ? cardInfo?.Masterplan_Y_Postion_Desktop : cardInfo?.attributes?.Master_Plan_Card?.Y_Position_Desktop}
			reset>
			<motion.div className={`masterplan-main-card ${facility && "facility"}`}
				initial={{ opacity: 0 }}
				whileInView={{ opacity: !showData ? !isMobile ? 0 : 1 : 1, x: 0 }}
				transition={{ delay: 0.1, duration: .5 }}
				exit={{ opacity: 0 }}
				viewport={{ once: true }}
				key={facility ? cardInfo?.Masterplan_Y_Postion_Desktop : cardInfo?.attributes?.Master_Plan_Card?.Y_Position_Desktop}
				style={{
					top:

						!isMobile &&
						(

							facility ?
								`${cardInfo?.Masterplan_Y_Postion_Desktop > 59 ?
									cardInfo?.Masterplan_Y_Postion_Desktop - 40
									: cardInfo?.Masterplan_Y_Postion_Desktop
								}%`
								:

								`${cardInfo?.attributes?.Master_Plan_Card?.Y_Position_Desktop > 59 ?
									cardInfo?.attributes?.Master_Plan_Card?.Y_Position_Desktop - 40
									: cardInfo?.attributes?.Master_Plan_Card?.Y_Position_Desktop

								}%`
						)

					,
					left: !isMobile &&
						(

							facility ?
								`${cardInfo?.Masterplan_X_Postion_Desktop < 50 ?
									cardInfo?.Masterplan_X_Postion_Desktop + 5 :
									cardInfo?.Masterplan_X_Postion_Desktop - 43
								}%`
								:
								`${cardInfo?.attributes?.Master_Plan_Card?.X_Position_Desktop < 50 ?
									cardInfo?.attributes?.Master_Plan_Card?.X_Position_Desktop + 5 :
									cardInfo?.attributes?.Master_Plan_Card?.X_Position_Desktop - 43
								}%`
						)
					,
				}}
			>
				<div className="image-container">
					<div className="overlay"></div>
					{cardInfo &&
						facility ?
						cardInfo?.Masterplane_Img_Desktop?.data?.attributes?.url &&
						<Image
							src={BASE_URL + (isMobile ? cardInfo?.Masterplan_Img_Mobile?.data?.attributes?.url :
								cardInfo?.Masterplane_Img_Desktop?.data?.attributes?.url)}
							layout="fill" objectFit="cover" alt={cardInfo?.Masterplan_Img_Mobile.data.attributes.name} /> :

						<Image src={BASE_URL + (isMobile ? cardInfo?.attributes?.Master_Plan_Card?.Img_Mobile?.data?.attributes?.url : cardInfo?.attributes?.Master_Plan_Card?.Img_Desktop?.data?.attributes?.url)} layout="fill" objectFit="cover" alt={cardInfo?.attributes.Master_Plan_Card.Img_Desktop.data.attributes.name} />
					}
				</div>
				<FadeIn customClass="card-info" xValue={15}>
					<h3 className="title _eleX">{
						facility ? cardInfo.Facilitie_Name : cardInfo?.attributes?.Master_Plan_Card?.Phase_Name
					}</h3>
					{!isMobile && !facility &&
						<p className="details _eleX">
							{cardInfo?.attributes?.Master_Plan_Card?.Description}
						</p>
					}
					{facility &&
						<p className="details _eleX">
							{cardInfo.Masterplane_Description}
						</p>
					}
					{!facility &&
						<>
							<div className="unitsType _eleX">
								<div className="icon-container">
									{cardInfo &&
										<Image src={BASE_URL + cardInfo?.attributes.Master_Plan_Card.Icon.data.attributes.url} layout="fill" objectFit="contain" alt={cardInfo?.attributes.Master_Plan_Card.Icon.data.attributes.name} />
									}
								</div>
								<span className="desc">{cardInfo?.attributes?.Master_Plan_Card?.Icon_Text}</span>
							</div>
							<div className="buttons-container _eleX">
								{!isMobile ?
									<a href={BASE_URL + cardInfo?.attributes?.Master_Plan_Card?.Pdf.data.attributes.url}
										target="_blank"
										rel="noopener noreferrer"
										aria-label="link">
										<Button text={
											isMobile ?
												cardInfo?.attributes?.Master_Plan_Card?.Button_Text1 :
												cardInfo?.attributes?.Master_Plan_Card?.Button_Text1.split(" ")[1]
										} whiteButton whiteBorder />
									</a>
									:
									!cardInfo?.attributes?.Master_Plan_Card?.Slug &&
									<a href={BASE_URL + cardInfo?.attributes?.Master_Plan_Card?.Pdf.data.attributes.url}
										target="_blank"
										rel="noopener noreferrer"
										aria-label="link">
										<Button text={
											isMobile ?
												cardInfo?.attributes?.Master_Plan_Card?.Button_Text1 :
												cardInfo?.attributes?.Master_Plan_Card?.Button_Text1.split(" ")[1]
										} whiteButton whiteBorder />
									</a>
								}
								{cardInfo?.attributes?.Master_Plan_Card?.Button_Text2 &&
									cardInfo?.attributes?.Master_Plan_Card?.Slug &&
									<div
										onClick={() => { setNextRoute(cardInfo?.attributes?.Master_Plan_Card?.Phase_Name) }}
									>
										<Button text={
											isMobile ?
												cardInfo?.attributes?.Master_Plan_Card?.Button_Text2 :
												cardInfo?.attributes?.Master_Plan_Card?.Button_Text2.split(" ")[0]
										}
											blackStyleMaster={!isMobile}
											whiteButton={isMobile}
											whiteBorder={isMobile}
											link={`/projects/${projectSlug}/${cardInfo?.attributes?.Master_Plan_Card?.Slug}`} />
									</div>}
							</div>
						</>
					}
				</FadeIn>
				<div className="close-btn" onClick={() => { setShowData(false), setActivePhase(-1) }}>
					<svg clipRule="evenodd" fillRule="evenodd" strokeLinejoin="round" strokeMiterlimit="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m12 10.93 5.719-5.72c.146-.146.339-.219.531-.219.404 0 .75.324.75.749 0 .193-.073.385-.219.532l-5.72 5.719 5.719 5.719c.147.147.22.339.22.531 0 .427-.349.75-.75.75-.192 0-.385-.073-.531-.219l-5.719-5.719-5.719 5.719c-.146.146-.339.219-.531.219-.401 0-.75-.323-.75-.75 0-.192.073-.384.22-.531l5.719-5.719-5.72-5.719c-.146-.147-.219-.339-.219-.532 0-.425.346-.749.75-.749.192 0 .385.073.531.219z" /></svg>
				</div>
			</motion.div>
		</AnimatePresence>
	);
}
